import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { dl_insuranceActions } from "../../actions";
import { AssignDealNumber } from "./AssignDealNumber";
import { DocumentSubmission } from "./DocumentSubmission";
import {OrgDropdown} from "../org/OrgDropdown";


// Copied from EditDeal
function DriversLicenseInsurance(props) {
  const { authentication, dl_insurances } = props;
  const org_id = props.match.params.id;

  useEffect(() => {
    props.getList(org_id);
  }, [org_id]);

  // Below we will map the result of
  return (
    <>
      <h3>DL &amp; Insurance</h3>

      <form>

        <div className="dlInsuranceWrapper">

          <div className="dlInsuranceListing">
            {dl_insurances?.list?.map((identity_jacket) => {
            return (
                <DocumentSubmission
                  deal_or_identity_jacket={identity_jacket}
                  org_id={org_id}
                  newToken={authentication?.jwt}
                  key={identity_jacket.deal_jacket_id}
                />
              );
          })}

            {dl_insurances?.last_added_identity_document_packet && dl_insurances.deal_jacket_with_identity_documents ?
              <DocumentSubmission
              deal_or_identity_jacket={dl_insurances.deal_jacket_with_identity_documents}
              org_id={org_id}
              newToken={authentication?.jwt}
              key={dl_insurances.deal_jacket_with_identity_documents.deal_jacket_id}
              recently_added={true}
            /> :
              <></>}
          </div>

          <div className="dlInsuranceAssignDealNumber">
            <AssignDealNumber
              org_id={org_id}
              newToken={authentication?.jwt}
            />
          </div>

        </div>

      </form>
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, dl_insurances } = state;
  return {
    dl_insurances,
    authentication,
  };
}

const actionCreators = {
  getList: dl_insuranceActions.getList,
};

const connectedDriversLicenseInsurance = connect(
  mapStateToProps,
  actionCreators
)(DriversLicenseInsurance);
export { connectedDriversLicenseInsurance as DriversLicenseInsurance };
